import { Box, Flex, Stack, Text } from "@storyofams/react-ui";
import Image from "next/image";

export const TrippleQuote = ({ content }) => {
  if (!content.quotes && !content.quotes.lenght) return null;
  return (
    <Box width={"100%"} borderTop={"1px solid #E2DFDF"}>
      {content.quotes.map(({ image, title, description }) => (
        <Stack
          width={"100%"}
          space={[1, 5]}
          key={title}
          justifyContent={"space-between"}
          flexDirection={["column", "row"]}
          borderBottom={"1px solid #E2DFDF"}
          py={[3, 4]}
        >
          <Flex alignItems={"center"}>
            <Box
              width={80}
              height={80}
              borderRadius={"full"}
              position={"relative"}
              mr={[2, 3]}
              border={"1px solid #E2DFDF"}
            >
              {image.filename && (
                <Image
                  objectFit="cover"
                  layout="fill"
                  src={image.filename}
                ></Image>
              )}
            </Box>
            <Text
              fontFamily={"DINPro"}
              fontSize={["24px", "36px"]}
              lineHeight={["28.8px", "43.2px"]}
              color={"#1D1D1B"}
            >
              {title}
            </Text>
          </Flex>
          <Text
            color={"#1D1D1B"}
            fontSize={["16px", "18px"]}
            lineHeight={["22.4px", "25.2px"]}
            maxWidth={"630px"}
          >
            {description}
          </Text>
        </Stack>
      ))}
    </Box>
  );
};
